import GameState from "slotworks/model/game-state";
import { Exit } from "slotworks/state-machine/data/exit";
import Decision from "slotworks/state-machine/decisions/decision";
import ICSpinRecord from "integration/revolver/schema/spin-record";
import ICFreespinRecord from "integration/revolver/schema/freespin-record";

export default class HasCoinsDecision extends Decision {
    public evaluate() {
        const icrecord = GameState.getCurrentGame().getCurrentRecord() as ICSpinRecord | ICFreespinRecord;

        if(icrecord.underCoinSymbols.size > 0)
            return Exit.True;
        

        return Exit.True;
    }
}